<template>
  <div class="Withdraw">
    <h3 class="mb-3 text-right">Solicitud de retiro</h3>
    <b-card class="mb-3">
      <b-card-text>
        <b-container>
          <b-row align-v="center">
            <b-col lg="1" md="2" sm="2" cols="4">
              <div
                :class="color"
                class="pt-3 pb-3 text-center text-font-white"
                style="border-radius: 100px; font-size: 20px"
              >
                1
              </div>
            </b-col>
            <b-col lg="3" md="2" sm="2" cols="8">
              <div class="text-font-black" style="font-size: 18px">
                Seguridad
              </div>
            </b-col>
            <b-col lg="1" md="2" sm="2" cols="4">
              <div
                :class="color1"
                class="pt-3 pb-3 text-center text-font-white colorStep"
                style="border-radius: 100px; font-size: 20px"
              >
                2
              </div>
            </b-col>
            <b-col lg="3" md="2" sm="2" cols="8">
              <div class="text-font-black" style="font-size: 18px">Cuentas y montos</div>
            </b-col>
            <b-col lg="1" md="2" sm="2" cols="4">
              <div
                :class="color2"
                class="pt-3 pb-3 text-center text-font-white"
                style="border-radius: 100px; font-size: 20px"
              >
                3
              </div>
            </b-col>
            <b-col lg="3" md="2" sm="2" cols="8">
              <div class="text-font-black" style="font-size: 18px">
                Monto y confirmación
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-card-text>
    </b-card>
    <b-card
      header-tag="header"
      header-class="card-color"
      class="mb-4"
      style="border-radius: 25px"
      v-if="next == 1"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="8" cols="8">
            <div class="text-left card-title-white">
              2FA - Autenticación de dos factores
            </div>
          </b-col>
        </b-row>
      </template>
      <b-card-text>
        <b-list-group>
          <div class="text-center text-font-black mb-3" style="font-size: 20px">
            Ingresa el código de la aplicación de autenticación que
            esta asociada a tu cuenta.
          </div>
          <b-container>
            <b-row align-h="center">
              <b-col lg="6">
                <b-form-input
                  v-model="code"
                  placeholder=""
                  type="number"
                  size="sm"
                  class="shadow-sm bg-white rounded"
                ></b-form-input>
              </b-col>
            </b-row>
            <p class="text-font-black">
              Agregar el código de 6 dígitos que proporciona Google
              Authenticator
            </p>
            <br />

            <b-row align-h="center" class="">
              <b-col>
                <b-button
                  style="border-radius: 15px; border: none"
                  class="card-color pl-5 pr-5 pb-2 pt-2"
                  size="lg"
                  v-if="!progress"
                  @click="step1()"
                  :disabled="checkAuth"
                >
                  <span class="text-font-white" style="font-size: 18px"
                    >Continuar</span
                  >
                </b-button>
                <div v-if="progress" class="text-center text-primary">
                  <b-spinner small class="align-middle"></b-spinner>
                  <strong class="ml-2">Cargando...</strong>
                </div>
              </b-col>
            </b-row>
            <div class="text-light-black mt-3">
              Si perdiste tu código 2FA escribenos a nuestro chat de ayuda o nuestro<br />
             WhatsApp <a target="_blank" href="https://wa.me/message/GLVP4YY6UUQ4M1">presionando aqui</a>  y te contactaremos para que recuperes
              tu cuenta.
            </div>
            <router-link :to="{ name: 'Chat'}">
              <div class="text-light-black mt-3">
              Chat de ayuda
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="card-color p-1 rounded-circle"
                height="30px"
                viewBox="0 0 24 24"
                width="30px"
                fill="#FFFFFF"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
                />
              </svg>
            </div>
            </router-link>
            
          </b-container>
        </b-list-group>
      </b-card-text>
    </b-card>
    <b-card
      header-tag="header"
      header-class="card-color"
      class="mb-4"
      style="border-radius: 25px"
      v-if="next == 2"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="8" cols="8">
            <div class="text-left card-title-white">
              Seleccionar cuentas
            </div>
          </b-col>
        </b-row>
      </template>
      <b-card-text>
        <b-list-group>
          <b-container>
            <b-row>
              <b-col>
                <div
                  class="text-left text-font-black mb-2"
                  style="font-size: 15px"
                >
                Seleccionar la cuenta en donde se va a realizar el retiro
                 <!--  Las colocaciones se reciben en los primeros 7 dias de cada mes,
                  si esta fuera de esta fecha su inversion quedara programada
                  para el proximo mes -->
                </div>
              </b-col>
            </b-row>

            <b-row align-h="center">
              <b-col v-if="account">
                <div class="text-font-black text-left">
                  Cuenta de donde se realiza el retiro
                </div>
                <b-list-group class="p-2">
                  <b-list-group-item
                    class="flex-column align-items-start"
                    style="border-radius: 15px; border-color: #121419"
                  >
                    <b-row align-v="center" align-h="start">
                      <b-col md="3 ">
                        <img
                          src="../assets/LogoSSBG.png"
                          height="50px"
                          alt=""
                        />
                      </b-col>
                      <b-col md="6" v-if="account">
                        <h5 class="mb-1 text-font-black text-left">
                          {{ account.name }}
                        </h5>
                        <p class="mb-1 text-light-black text-left">
                          <strong>Creado el {{ account.created_at }}</strong>
                        </p>
                      </b-col>
                      <b-col md="3">
                        <p class="mb-1 text-light-black text-center">Saldo</p>
                        <h5
                          class="mb-1 text-font-black text-center"
                          style="font-size: 20px"
                        >
                          $ {{ total_balance }}
                        </h5>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
            <div class="text-font-black text-left">
              Selecciona la cuenta a depositar
            </div>
            <b-row align-h="center" align-v="center">
              <b-col v-if="bankSelect" lg="10">
                <b-list-group class="p-2">
                  <b-list-group-item
                    class="flex-column align-items-start"
                    style="border-radius: 15px; border-color: #121419"
                  >
                    <b-row align-v="center" align-h="start">
                      <b-col md="3 " cols="12">
                        <img
                          src="../assets/LogoSSBG.png"
                          height="50px"
                          alt=""
                        />
                      </b-col>
                      <b-col md="3" cols="12">
                        <h5 class="mb-1 text-font-black">
                          {{ bankSelect.name }}
                        </h5>
                        <p class="mb-1 text-light-black">
                          <strong
                            >#*******{{
                              bankSelect.number.substr(
                                bankSelect.number.length - 4,
                                bankSelect.number.length
                              )
                            }}</strong
                          >
                        </p>
                      </b-col>
                      <b-col md="6" cols="12">
                        <h5 class="mb-1 text-font-black">
                          {{ bankSelect.email }}
                        </h5>
                        <p class="mb-1 text-light-black">
                          <strong
                            >ACH*******{{
                              bankSelect.ach.substr(
                                bankSelect.number.length - 4,
                                bankSelect.number.length
                              )
                            }}</strong
                          >
                        </p>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col lg="2">
                <b-button
                  style="border-radius: 15px; border: none"
                  class="card-color pl-3 pr-3 pb-2 pt-2 mb-3"
                  size="lg"
                  v-b-modal.modal-banks
                >
                  <span class="text-font-white" style="font-size: 18px"
                    >Seleccionar</span
                  >
                </b-button>
              </b-col>
              
            </b-row>
            
            <b-row align-h="center" class="mt-5">
              <b-col>
                <b-button
                  style="border-radius: 15px; border: none"
                  class="mr-3 pl-5 pr-5 pb-2 pt-2"
                  size="lg"
                  @click="
                    code = '';
                    next--;
                  "
                >
                  <span class="text-font-white" style="font-size: 18px"
                    >Cancelar</span
                  >
                </b-button>
                <b-button
                  style="border-radius: 15px; border: none"
                  class="card-color pl-5 pr-5 pb-2 pt-2"
                  size="lg"
                  @click="step2"
                >
                  <span class="text-font-white" style="font-size: 18px"
                    >Continuar</span
                  >
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-list-group>
      </b-card-text>
    </b-card>
    <b-card
      header-tag="header"
      header-class="card-color"
      class="mb-4"
      style="border-radius: 25px"
      v-if="next == 3"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="8" cols="8">
            <div class="text-left card-title-white">Realizar el pago</div>
          </b-col>
        </b-row>
      </template>
      <b-card-text>
        <b-list-group>
          <b-container>
            <b-row>
              <b-col>
                <div
                  class="text-left text-font-black mb-2"
                  style="font-size: 15px"
                >
                
                  Los retiros se realizan los primeros 7 días de cada mes,
                  si está fuera de esta fecha su Colocación quedará programada
                  para el próximo mes
                </div>
              </b-col>
            </b-row>

            <b-row align-h="center">
              <b-col v-if="account">
                <div class="text-font-black text-left">
                  Cuenta de retiro
                </div>
                <b-list-group class="p-2">
                  <b-list-group-item
                    class="flex-column align-items-start"
                    style="border-radius: 15px; border-color: #121419"
                  >
                    <b-row align-v="center" align-h="start">
                      <b-col md="3 ">
                        <img
                          src="../assets/LogoSSBG.png"
                          height="50px"
                          alt=""
                        />
                      </b-col>
                      <b-col md="6" v-if="account">
                        <h5 class="mb-1 text-font-black text-left">
                          {{ account.name }}
                        </h5>
                        <p class="mb-1 text-light-black text-left">
                          <strong>Creado el {{ account.created_at }}</strong>
                        </p>
                      </b-col>
                      <b-col md="3">
                        <p class="mb-1 text-light-black text-center">Saldo</p>
                        <h5
                          class="mb-1 text-font-black text-center"
                          style="font-size: 20px"
                        >
                          $ {{ total_balance }}
                        </h5>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
            </b-row>
            <div class="text-font-black text-left">
              Cuenta a depositar
            </div>
            <b-row align-h="center" align-v="center">
              <b-col v-if="bankSelect" lg="12">
                <b-list-group class="p-2">
                  <b-list-group-item
                    class="flex-column align-items-start"
                    style="border-radius: 15px; border-color: #121419"
                  >
                    <b-row align-v="center" align-h="start">
                      <b-col md="3 " cols="12">
                        <img
                          src="../assets/LogoSSBG.png"
                          height="50px"
                          alt=""
                        />
                      </b-col>
                      <b-col md="3" cols="12">
                        <h5 class="mb-1 text-font-black">
                          {{ bankSelect.name }}
                        </h5>
                        <p class="mb-1 text-light-black">
                          <strong
                            >#*******{{
                              bankSelect.number.substr(
                                bankSelect.number.length - 4,
                                bankSelect.number.length
                              )
                            }}</strong
                          >
                        </p>
                      </b-col>
                      <b-col md="6" cols="12">
                        <h5 class="mb-1 text-font-black">
                          {{ bankSelect.email }}
                        </h5>
                        <p class="mb-1 text-light-black">
                          <strong
                            >ACH*******{{
                              bankSelect.ach.substr(
                                bankSelect.number.length - 4,
                                bankSelect.number.length
                              )
                            }}</strong
                          >
                        </p>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              
            </b-row>
            <b-row align-h="center">
              <b-col lg="5" md="7">
                <div
                  style="font-size: 24px"
                  class="text-light-black-title mt-2"
                >
                  Monto a retirar
                </div>
                <b-form-input
                  v-model="amount_withdraw"
                  placeholder=""
                  type="number"
                  min="0"
                  size="sm"
                  class="shadow-sm bg-white rounded"
                ></b-form-input>
              </b-col>
              <b-col lg="5" md="7">
                <div
                  style="font-size: 24px"
                  class="text-light-black-title mt-2"
                >
                  Fecha de retiro
                </div>
                <b-form-datepicker
                      class="text-left"
                      id="datepicker-dateformat"
                      :date-format-options="{
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                        weekday: 'short',
                      }"
                      locale="es"
                      :min="date_min"
                      placeholder="Fecha de pago"
                      v-model="date_withdraw"
                    ></b-form-datepicker>
              </b-col>
            </b-row>
            
            <b-form-checkbox
              id="checkbox-1"
              v-model="status"
              name="checkbox-1"
              value="accepted"
              class="mt-5"
              unchecked-value="not_accepted"
            >
              <span class="text-font-black"
                >He leído y acepto los términos y condiciones de invertir con
                BB</span
              >
            </b-form-checkbox>
            <b-row align-h="center" class="mt-5">
              <b-col>
                <b-button
                  style="border-radius: 15px; border: none"
                  class="mr-3 pl-5 pr-5 pb-2 pt-2"
                  size="lg"
                  v-if="!progress"
                  @click="
                    code = '';
                    next--;
                  "
                >
                  <span class="text-font-white" style="font-size: 18px"
                    >Cancelar</span
                  >
                </b-button>
                <b-button
                  style="border-radius: 15px; border: none"
                  class="card-color pl-5 pr-5 pb-2 pt-2"
                  size="lg"
                  v-if="!progress"
                  @click="step3()"
                  :disabled="check"
                >
                  <span class="text-font-white" style="font-size: 18px"
                    >Realizar retiro</span
                  >
                </b-button>
                <div v-if="progress" class="text-center text-primary">
                  <b-spinner small class="align-middle"></b-spinner>
                  <strong class="ml-2">Cargando...</strong>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-list-group>
      </b-card-text>
    </b-card>
    
    <b-modal
      id="modal-banks"
      ref="modal"
      title-class="text-font-black"
      title="Cuentas bancarias registradas"
      size="lg"
      hide-footer
    >
      <b-list-group class="p-2" v-for="account of bank" :key="account.id">
        <b-list-group-item
          href="#"
          class="flex-column align-items-start"
          style="border-radius: 15px; border-color: #121419"
          @click="selectBank(account)"
        >
          <b-row align-v="center" align-h="start">
            <b-col md="3 " cols="12">
              <img src="../assets/LogoSSBG.png" height="50px" alt="" />
            </b-col>
            <b-col md="3" cols="12">
              <h5 class="mb-1 text-font-black">
                {{ account.name }}
              </h5>
              <p class="mb-1 text-light-black">
                <strong
                  >#*******{{
                    account.number.substr(
                      account.number.length - 4,
                      account.number.length
                    )
                  }}</strong
                >
              </p>
            </b-col>
            <b-col md="6" cols="12">
              <h5 class="mb-1 text-font-black">
                {{ account.email }}
              </h5>
              <p class="mb-1 text-light-black">
                <strong
                  >ACH*******{{
                    account.ach.substr(
                      account.number.length - 4,
                      account.number.length
                    )
                  }}</strong
                >
              </p>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { mapActions, mapState } from "vuex";

export default {
  name: "Withdraw",
  data() {
    return {
        date_withdraw: null,
      id_user: Cookies.get("id"),
      id_account: null,
      loadaccount: true,
      total_balance: null,
      code: "",
      amount_withdraw: null,
      description: "",
      status: "not-accepted",
      next: 1,
      factor: Cookies.get("factor"),
      date_min: new Date(), 
      bank: [],
      bankSelect: null,
      bank_id: null,
      progress: false,
      account: [
        {
          overview: {
            balance: 0,
          },
        },
      ],
    };
  },
  methods: {
    ...mapActions(["getBank", "Verify2FA", "getAccount", "Withdrawfunds"]),
    selectBank(data){
        this.bankSelect = data
        this.bank_id = data.id
        this.$nextTick(() => {
        this.$bvModal.hide("modal-banks");
      });
    },
    AllBank() {
      this.getBank(this.id_user)
        .then((response) => {
          if (response.code == 200) {
            this.bank = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },
    AllAccount() {
      console.log(this.id_user);
      this.getAccount(this.id_user)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.loadaccount = false;
            this.account = response.data[0];
            this.id_account = String(response.data[0].id);
            this.total_balance = response.data[0].overview.balance;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },
    step1() {
      this.progress = true;
      console.log(this.code);
      let form = {
        google_code: this.code,
      };
      this.Verify2FA(form)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.next++;
            this.progress = false;
          } else {
            this.progress = false;

            Swal.fire({
              title: "Error",
              text: "No es el código correcto",
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.progress = false;

          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Intente más tarde",
            icon: "error",
          });
        });
    },
    step2() {
      this.date_min = new Date()
      if (this.bankSelect == null) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe seleccionar una cuenta a depositar",
          icon: "warning",
        });
      } else {
        this.next++;
      } 
    },
    step3() {
      if ( this.amount_withdraw > this.total_balance){
        Swal.fire({
          title: "¡Atención!",
          text: "El monto a retirar es superior al saldo disponible en su cuenta",
          icon: "warning",
        });
      } else if ( this.amount_withdraw < 0){
        Swal.fire({
          title: "¡Atención!",
          text: "El monto a retirar debe ser superior a 0",
          icon: "warning",
        });
      } else {
        Swal.fire({
        title: "¡Atención!",
        text:
          "¿Está seguro que desea hacer un retiro de $" + this.amount_withdraw + "?",
        icon: "question",
      }).then((result) => {
        if (result) {
          this.progress = true;

          let form = {
            user_account_id: this.id_account,
            user_bank_id: String(this.bank_id),
            type_transaction_id: '8',
            amount: this.amount_withdraw,
            date_payment: this.date_withdraw
          };
          this.Withdrawfunds(form)
            .then((response) => {
              console.log(response);
              if (response.code == 200) {
                this.progress = false;
                Swal.fire({
                  title: "Listo",
                  text: "Su solicitud de retiro ha sido realizada con éxito",
                  icon: "success",
                }).then((result2) => {
                  if (result2) {
                    this.$router.push("/home");
                  }
                });
              } else if (response.code == 400) {
                this.progress = false;
                Swal.fire({
                  title: "Fecha no válida",
                  text: "Debe seleccionar una fecha entre el 1 y 7 de cada mes",
                  icon: "warning",
                })
              } else {
                this.progress = false;

                Swal.fire({
                  title: "Error",
                  text: "No se pudo realizar su solicitud",
                  icon: "error",
                });
              }
            })
            .catch((error) => {
              this.progress = false;

              console.log(error);
              Swal.fire({
                title: "Error",
                text: "Intente más tarde",
                icon: "error",
              });
            });
        }
      });
      }
      
    },
  },
  computed: {
    ...mapState({
      me_user: (state) => state.me_user,
    }),
    color() {
      return {
        colorStep: this.next == 1,
        "bg-dark": this.next != 1,
      };
    },
    color1() {
      return {
        colorStep: this.next == 2,
        "bg-dark": this.next != 2,
      };
    },
    color2() {
      return {
        colorStep: this.next == 3,
        "bg-dark": this.next != 3,
      };
    },
    check() {
      return this.status == "accepted" ? false : true;
    },
    checkAuth() {
      return this.code.length == 6 ? false : true;
    },
  },
  mounted() {
    this.AllBank();
    this.AllAccount();
    if (this.factor == 0) {
      this.next = 2
    }
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
.card-header:first-child {
  border-radius: 15px 15px 0 0;
}
.colorStep {
  background-color: #121419;
}
</style>